/**
 * How strictly email verification is enforced. Starts at `banner` (UI nudge
 * only, no blocking) and can be tightened to `softgate` (block sensitive
 * actions) or `hardgate` (block the whole app) purely by editing config/auth —
 * no code change or deploy required.
 */
var EmailVerificationEnforcement;
(function (EmailVerificationEnforcement) {
    EmailVerificationEnforcement["banner"] = "banner";
    EmailVerificationEnforcement["softgate"] = "softgate";
    EmailVerificationEnforcement["hardgate"] = "hardgate";
})(EmailVerificationEnforcement || (EmailVerificationEnforcement = {}));
const toEnforcement = (data) => {
    switch (data) {
        case 'softgate':
            return EmailVerificationEnforcement.softgate;
        case 'hardgate':
            return EmailVerificationEnforcement.hardgate;
        default:
            return EmailVerificationEnforcement.banner;
    }
};
const emptyAuthConfigDoc = () => {
    return {
        emailVerification: {
            enforcement: EmailVerificationEnforcement.banner,
            cutoffISO: '',
            sensitiveActions: []
        },
        passkeys: {
            enabled: false,
            rpId: '',
            rpName: '',
            allowedOrigins: []
        },
        mfa: {
            enabled: false,
            otpTtlSeconds: 600,
            sessionTtlSeconds: 43200,
            forcedRoles: []
        }
    };
};
const toAuthConfigDoc = (data) => {
    const config = emptyAuthConfigDoc();
    if (!data)
        return config;
    const ev = data.emailVerification;
    if (ev) {
        config.emailVerification.enforcement = toEnforcement(ev.enforcement);
        config.emailVerification.cutoffISO = ev.cutoffISO ?? '';
        config.emailVerification.sensitiveActions = Array.isArray(ev.sensitiveActions)
            ? ev.sensitiveActions
            : [];
    }
    const pk = data.passkeys;
    if (pk) {
        config.passkeys.enabled = pk.enabled ?? false;
        config.passkeys.rpId = pk.rpId ?? '';
        config.passkeys.rpName = pk.rpName ?? '';
        config.passkeys.allowedOrigins = Array.isArray(pk.allowedOrigins)
            ? pk.allowedOrigins
            : [];
    }
    const mfa = data.mfa;
    if (mfa) {
        config.mfa.enabled = mfa.enabled ?? false;
        config.mfa.otpTtlSeconds = mfa.otpTtlSeconds ?? 600;
        config.mfa.sessionTtlSeconds = mfa.sessionTtlSeconds ?? 43200;
        config.mfa.forcedRoles = Array.isArray(mfa.forcedRoles)
            ? mfa.forcedRoles.map((r) => r)
            : [];
    }
    return config;
};
export { EmailVerificationEnforcement, emptyAuthConfigDoc, toAuthConfigDoc };
//# sourceMappingURL=auth.js.map